import { observer } from 'mobx-react';
import React from 'react';
import { BrowseNavigationItemSelected, BrowseNavigationItemStyle, BrowseNavigationItemType } from '@udemy/browse-event-tracking';
import { Tracker } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { ExploreMenu } from '../../components/explore-menu.react-component';
import { getCertifiedNavigationConfig } from '../../config/desktop/get-certified-nav-config';
import { HeaderMenuProvider } from '../../contexts/header-menu-context';
/**
 * Get Certified dropdown content. Uses ExploreMenu with async navigation config:
 * content is loaded via fetchChildren when the menu is shown (no hasData guard).
 */
/**
 * Fires BrowseNavigationItemSelected when user clicks the Exam Vouchers item in Get Certified
 * (desktop). Keeps desktop eventing in parity with mobile.
 */
function createExamVouchersClickHandler() {
  return () => {
    Tracker.publishEvent(new BrowseNavigationItemSelected({
      id: 'exam-vouchers',
      style: BrowseNavigationItemStyle.NAVIGATION_DROPDOWN,
      type: BrowseNavigationItemType.CERTIFICATION_PREPARATION,
      uiRegion: 'main_nav'
    }));
  };
}
export const GetCertifiedNavContent = observer(({
  browseNavStore
}) => {
  const {
    gettext
  } = useI18n();
  const navigationConfig = getCertifiedNavigationConfig(browseNavStore, gettext, {
    onExamVouchersClick: createExamVouchersClickHandler()
  });
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "get-certified-nav"
  }, /*#__PURE__*/React.createElement(HeaderMenuProvider, {
    navigationConfig: navigationConfig,
    autoInitialize: true
  }, /*#__PURE__*/React.createElement(ExploreMenu, null)));
});
//# sourceMappingURL=get-certified-nav.react-component.js.map